"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _pacomo = require("utils/pacomo");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormLink = function FormLink(_ref) {
    var children = _ref.children,
        link = _ref.link;


    return _react2.default.createElement(
        "a",
        { href: link, target: "_blank" },
        children
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(FormLink);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FormLink.js
// module id = 154
// module chunks = 0